import { useSession } from "@/platform/session/use-session"

export const useClientInitialization = () => {
  const session = useSession()
  return { isInitialized: session.isAuthenticated, error: null }
}
